export var SpecialServiceType;
(function (SpecialServiceType) {
    SpecialServiceType["Insurance"] = "Insurance";
    SpecialServiceType["Aeroexpress"] = "Aeroexpress";
})(SpecialServiceType || (SpecialServiceType = {}));
